import React from "react";
import { ExternalArrowGlyph } from "./style";

const ExternalArrow = () => <ExternalArrowGlyph aria-hidden="true" />;

export default ExternalArrow;
